import { motion, AnimatePresence } from "framer-motion";
import { Gauge, MapPin, Zap } from "lucide-react";
import PageHero from "@/components/PageHero";
import { IMAGES, PROJECTS, PROJECT_FILTERS } from "@/data/site";

export default function Projects() {
  return (
    <div data-testid="page-projects">
      <PageHero
        crumb="Proyek"
        eyebrow="Projects & Portfolio"
        title="Our solar PV installation footprint across Indonesia"
        desc="From commercial rooftops to utility-scale power plants — proven track record of AJE’s EPC excellence.."
        image={IMAGES.officeAerial}
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        
        {/* GRID */}
       <motion.div layout className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
  <AnimatePresence mode="popLayout">
    {PROJECTS.map((p) => (
              <motion.article
                layout
                key={p.name}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.4 }}
                data-testid={`project-card-${p.name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")}`}
                className="group overflow-hidden rounded-2xl bg-white shadow-sm aje-card-hover"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={IMAGES[p.img]}
                    alt={p.name}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg font-bold text-slate-900">
                    {p.name}
                  </h3>
                  <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-500">
                    <span className="inline-flex items-center gap-1.5">
                      <Gauge className="h-4 w-4 text-blue-900" /> {p.capacity}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <MapPin className="h-4 w-4 text-blue-900" /> {p.location}
                    </span>
                  </div>
                  <p className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-700">
                    <Zap className="h-4 w-4" /> {p.impact}
                  </p>
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
        </motion.div>
      </section>
    </div>
  );
}
